module.exports = "https://trybtryb-legacy.web.app/img/flare.17253a22.webp";